import React from 'react'

import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	}
}))

const DeactivationDialog = (props) => {
	const classes = useStyles()

	let { isShown, setIsShown, confirmDeactivation } = props

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 24
				}}>
				DEACTIVATE CONTACT
			</DialogTitle>
			<DialogContent>
				<Typography
					variant="body2"
					style={{
						marginBottom: 24
					}}>
					This action will lock this individual contact out of the system.
				</Typography>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" onClick={() => confirmDeactivation()} color="secondary">
					DEACTIVATE CONTACT
				</Button>
				<Button variant="outlined" onClick={() => setIsShown(false)} color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default DeactivationDialog
